// main.js (optimizado)
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AuthService from './plugins/AuthService'
import vuetify from './plugins/vuetify'
import VueStash from 'vue-stash'
import store from './plugins/store'
import RouterLoader from './plugins/RouterLoader'
import ToastService from './plugins/ToastService/ToastService.js'

// --- Init helpers ---
function inicializarStore() {
  Vue.use(VueStash)
  const raw = localStorage.getItem('authInfo')
  if (raw) {
    const a = JSON.parse(raw)
    store.usuario.nombre = `${a.apellido} ${a.nombre}`
    store.usuario.jerarquiaId = a.jerarquiaId
    store.usuario.usuarioId = a.id
  }
}

function inicializarAuth() {
  const baseDev = 'http://localhost:5000'
  const baseProd = 'https://gestioniua.blito.ar'
  const env = (process.env.NODE_ENV || 'development').toLowerCase()
  const base = env === 'production' ? baseProd : baseDev

  Vue.use(AuthService, {
    router,
    base,
    baseApi: `${base}/api/v1`,
    refreshApi: '/auth/refresh-token',
    loginApi: '/auth/login',
    logoutApi: '/auth/logout',
    loginRoute: '/login',
    defaultRoute: '/',
    localStorageAuthInfo: 'authInfo',
    sessionStorage: false,
    menuLoader: async () => RouterLoader(router, store)
  })
}

let menuLoaded = false
function inicializarRouterLoader() {
  // Cargar menús sólo si hay sesión y solo una vez
  if (!menuLoaded) {
    const raw = localStorage.getItem('authInfo')
    const token = raw && JSON.parse(raw)?.token
    if (token) {
      RouterLoader(router, store)
      menuLoaded = true
    }
  }
}

function inicializarToastService() {
  Vue.use(ToastService, { store })
}

function inicializarInstanciaVue() {
  new Vue({
    router,
    data: { store },
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

function inicializarDespuesDeAuth() {
  // si ya hay sesión al arrancar, cargamos menús/rutas dinámicas
  const info = Vue.prototype.$auth?.getAuthInfo?.();
  if (info && info.token) {
    RouterLoader(router, store);
  }
}

// --- Boot ---
function init() {
  inicializarStore()
  inicializarAuth()
   inicializarDespuesDeAuth()  
  //inicializarRouterLoader()
  inicializarToastService()
  inicializarInstanciaVue()
}

init()
